export default __webpack_public_path__ + "media/images/images/banner/banner-8-05b4b0b6b52405364dc0aa13af5f28e6.jpg";